import React from "react";

const NotFoundPage = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
      <div className="text-center px-4">
        <h1 className="display-1 fw-bold text-danger">404</h1>
        <h2 className="fs-2 text-dark">
          <span className="text-danger">Oops!</span> Page Not Found
        </h2>
        <p className="text-muted mt-3 mb-4">
          The page you’re looking for doesn’t exist or was moved.
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
